import { ClientDisconnectedError } from 'shared/services/ApiClient/errors'

export const isClientDisconnected = (error: unknown) => {
  return (
    error instanceof ClientDisconnectedError ||
    (error as NodeJS.ErrnoException).code === 'ECONNRESET' ||
    (error as NodeJS.ErrnoException).code === 'ECONNABORTED' ||
    (error as NodeJS.ErrnoException).code === 'ERR_STREAM_DESTROYED' ||
    (error as NodeJS.ErrnoException).message?.toLowerCase()?.includes('client disconnected')
  )
}
